class AnimateCounter {
  constructor(number, start, end, duration = 1000) {
    this.number = number;
    this.start = start;
    this.end = end;
    this.interval = duration;
    this.duration;
    this.addUp = true;
    this.mathValue = end;
  }

  render() {
    if(this.start > this.end) {
      this.mathValue = this.start;
      this.addUp = false;
    }

    this.duration = Math.floor(this.interval / this.mathValue);

    this.counter = setInterval(() => {
      if(this.addUp) {
        this.start +=1;
      } else {
        this.start -=1;
      }

      this.number.textContent = this.start;

      if(this.start == this.end) {
        clearInterval(this.counter);
      }
    }, this.duration);
  }

  init() {
    this.render();
  }
}

export default AnimateCounter;
